import { BFormSpinbutton } from './form-spinbutton';
import { pluginFactory } from '../../utils/plugins';
var FormSpinbuttonPlugin = /*#__PURE__*/pluginFactory({
  components: {
    BFormSpinbutton: BFormSpinbutton,
    BSpinbutton: BFormSpinbutton
  }
});
export { FormSpinbuttonPlugin, BFormSpinbutton };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/form-spinbutton/index.js
// module id = 213
// module chunks = 0